export const paragraphTokens = {
  fonts: {
    paragraphFontFamily: '$secondary'
  },
  fontWeights: {
    paragraphFontWeight: '$regular'
  }
}
